<template>
  <div class="table-block-container">
    <!-- TLV 25/02/2020 : S'il n'y a qu'une ou deux cartes dans le tableau, on les centre un peu-->
    <div style="width:16%;float: left;margin: 5px; box-sizing: border-box;" v-if="statusCardsFiltered.length < 3" />
    <div class="table-block" :class="{'table-block-small': statusCardsFiltered.length > 3}" v-for="card in statusCardsFiltered">
      <div
        :key="card.colorClass"
        class="table-block-inner dashboardStatusCard"
        v-bind:class="card.colorClass"
        @click="filterSendBox(card.changePageValue)">
        <div class="table-block-amount">
          {{commonfunctions.parseFloatOrInt(parseFloat(card.amount))}} €
        </div>
        <div v-bind:class="{'large-table-block-label' : card.isLarge, 'table-block-label' : !card.isLarge}">
          {{ $t(card.labelId) }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/* TLV 05/03/2020
* @brief Component qui affiche les cartes (le rectangle vert avec "Request Accepted", le rectangle jaune
*   appelé "Request Waiting", etc) sur le "Dashboard" (pour rappel la page d'accueil) de MoneyRoad.
*   Chaque carte à afficher est transmise via une structure json, transmise par CMDashboard.vue vers les propriétés
*   de ce component
*/
export default {
  name: 'StatusCardsList',
  props: ['statusCards', 'filterSendBox'],
  data () {
    return {
      commonfunctions: this.$engine.common.functions,
      statusCardsFiltered: []
    }
  },
  created () {
    this.statusCardsFiltered = this.statusCards.filter(card =>
      this.commonfunctions.showOnThisService(card.service, this.$engine.user.currentService.id)
    )
  }
}
</script>
